import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import '@/styles/application.css'

// Set CSRF token globally
axios.defaults.headers.common['X-CSRF-Token'] =
    document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

export function bootstrapPortal({ App, router, elId, portalName }) {
    document.addEventListener('DOMContentLoaded', () => {
        const el = document.getElementById(elId)

        if (!el) {
            console.warn(`⚠️ Could not find #${elId} to mount Vue.`)
            return
        }

        const app = createApp(App)
        app.use(router)
        app.use(createPinia())
        app.mount(el)

        console.log(`🔥 ${portalName} portal mounted.`)
    })
}
